import { images_folder } from "./client";
import { AuditOutlined, FileSearchOutlined } from "@ant-design/icons";
import { Image, Result } from "antd";

const ApplicationStatusPage = (props) => {
  return getStageContent(props.stage);
};

const getStageContent = (stage) => {
  switch (stage) {
    case "5_1":
      return onGoingReviewContent();
    case "5_2":
      return submittedToUSCIS();
    case "5_3":
      return USCISResponse();
    default:
      return "";
  }
};
const onGoingReviewContent = () => {
  return (
    <>
      {getHead()}
      <h1 className="status-heading">
        Greencard Application Status: Ongoing Review
      </h1>
      <Result
        icon={<FileSearchOutlined />}
        title="Your application is currently being reviewed by our team."
        extra={[
          <p>
            It typically takes 7 to 14 business days to complete the review.
          </p>,
          <p>
            If additional information is required, we will reach out to you via
            email or phone.
          </p>,
        ]}
      />
    </>
  );
};
const submittedToUSCIS = () => {
  return (
    <>
      {getHead()}
      <h1 className="status-heading">
        Application Status: Submitted to United States Citizenship & Immigration
        Services (USCIS)
      </h1>
      <Result
        icon={<AuditOutlined />}
        title="Your application package has been sent to USCIS for processing."
        extra={[
          <p>
            A response from USCIS may take 3 to 6 months. You will be notified
            via email once a response is received from USCIS.
          </p>,
        ]}
      />
    </>
  );
};
const USCISResponse = () => {
  return (
    <>
      {getHead()}
      <h1 className="status-heading">
        Application Status: Response from USCIS
      </h1>
      <Result
        icon={<AuditOutlined />}
        title="You have received a response on your application from USCIS."
      />
    </>
  );
};
const getHead = () => {
  return (
    <div className="sign-in-intro">
      <Image width={75} preview={false} src={images_folder("uk-flag.png")} />
    </div>
  );
};

export default ApplicationStatusPage;
